/**
 * Canonical English day/month name constants — indexed by Date#getDay() /
 * Date#getMonth(). These were independently re-declared in 8+ files (day
 * strips, headers, habit forms, capture toasts); import from here instead.
 * For locale-aware, screen-reader-facing labels prefer
 * `toLocaleDateString(undefined, {...})` — these constants are for the mono
 * eyebrow/chip aesthetic where the fixed EN forms are part of the design.
 */
export const DAY_LETTER = ['S', 'M', 'T', 'W', 'T', 'F', 'S'] as const;
export const DAY_SHORT = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'] as const;
export const DAY_UPPER = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'] as const;
export const DAY_LONG = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
] as const;

export const MONTH_SHORT = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
] as const;
export const MONTH_LONG = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
] as const;
